export default "__VITE_ASSET__CzlIhiwf__"